export const tableLocaleSettings = () => ({
  triggerDesc: 'Сортировать по убыванию',
  triggerAsc: 'Сортировать по возрастанию',
  cancelSort: 'Отменить сортировку',
  emptyText: '',
});
